'use strict';

/**
 * Page Designer client entry — shared PD behaviors.
 * Include via assets.addJs('/js/page-designer.js') on PD-backed pages (PLP, Blog Post, …).
 */
const pdAnimation = require('./page-designer/pdAnimation');

$(document).ready(function () {
    pdAnimation.init();
});
